/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaClock/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaClock({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaClock",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 16,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaClock.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 style={{'--as-1-1juHFW': alignSelf,'--mt-2-1juHFW': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1juHFW': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1juHFW': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1juHFW': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1juHFW': opacity,'--w-10-1juHFW': typeof width === 'number' ? `${width}px` : width,'--h-11-1juHFW': typeof height === 'number' ? `${height}px` : height,'--f-12-1juHFW': fill,'--a-7-1juHFW': isAnimated ? animation : "none",'--sd-8-1juHFW': isAnimated ? strokeDashoffset : 0,'--sd-9-1juHFW': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaClock.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.117 1.614A.857.857 0 103.311.1 10.789 10.789 0 00.208 2.584a.857.857 0 101.299 1.118 9.075 9.075 0 012.61-2.088zM8 16A6.857 6.857 0 108 2.286 6.857 6.857 0 008 16zM11.53.454a.857.857 0 011.159-.353c1.18.628 2.232 1.47 3.103 2.483a.857.857 0 01-1.299 1.118 9.073 9.073 0 00-2.61-2.088.857.857 0 01-.354-1.16zm-2.816 5.26a.714.714 0 00-1.428 0v3.429c0 .394.32.714.714.714h2.857a.714.714 0 100-1.428H8.714V5.714z"
 style={{'--f-12-1juHFW': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}